import  { useState, useEffect, useRef } from 'react';
import { useProduct } from '@/contexts/products-context';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {ImageGallery} from '@/components/ui/ImageGallery'
import {ArrowBigLeft} from "lucide-react"
import { ISelectedImgs } from '@/types/Sdata';
const Product = () => {
  const navigate = useNavigate();
  const { Selectedproduct, normalizeDateTime,GetSimilarImg,Submit,GetAiDescription,UpdateProductDetails,AddSelectedimgs,selectedimg} = useProduct();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [sizes, setSizes] = useState<{size:string,instock:boolean}[]>();
  const [price, setPrice] = useState(0);
  const [Sku,setsku]=useState<string>("");
  const [condition, setCondition] = useState('');
  // const [images,setimages]=useState<string[]|null>(null)
  const initRef = useRef<string | null>(null)

  const GetDescription=async(id:string)=>
  {
    if(Selectedproduct?.sku==""){
    const d=await GetAiDescription(id);
    setDescription(d);}
  }
  const Getsku=()=>{
     var k=Selectedproduct?.brand;
     var f=k?.slice(0,2);
     var s=Math.floor(Math.random()*(9999999-99999)+999999);
     var full=f?.concat(s.toString());
     setsku(full??"");
  }

  const AddSelectedimages=()=>{
   
    Selectedproduct?.image.forEach((imgs,i) => {
      const s:ISelectedImgs={
       Id:imgs.id,
       Url:imgs.url,
       Priority:i,
       Bgremove:false
      }
      if(s){
        AddSelectedimgs(s)
      }   
    });
    
  }

  useEffect(() => {
    if (Selectedproduct) {
       Getsku();
       GetDescription(Selectedproduct.id)
       GetSimilarImg(Selectedproduct.id)
      setTitle(Selectedproduct.title || '');
      setDescription(Selectedproduct.description || '');
      setPrice(Selectedproduct.price || 0);
      setSizes(Selectedproduct.variants ? Selectedproduct.variants.map(v => ({ size: v.size, instock: v.inStock })) : []);
      setCondition(Selectedproduct.condition || '');
      // setimages(Selectedproduct.image?Selectedproduct.image.map(v=>v.url):[])
      if (initRef.current !== Selectedproduct.id) {
        AddSelectedimages();
        initRef.current = Selectedproduct.id;
      }
    } else {
      navigate("/Reviewproducts");
    }
  }, [Selectedproduct, navigate]);

  if (!Selectedproduct) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center">
        <p>No product selected. Redirecting...</p>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen flex flex-col bg-gray-50">
     
      <div className="w-full text-md sm:text-lg items-center align-middle  font-semibold h-[5vh] sm:h-[7vh] bg-[#E2E2E2] flex sticky top-0 z-10 shrink-0">
        <Button className="  flex items-center cursor-pointer bg-transparent text-black border-none shadow-none hover:bg-transparent"
        onClick={()=>{
          navigate("/Reviewproducts")
        }}
        > <ArrowBigLeft/> back</Button>
        <div className="mx-5  sm:mx-14">Product</div>
        <div className="text-xs sm:text-lg font-normal truncate pr-4">{Selectedproduct?.title}</div>
      </div>

  
      <div className="flex flex-col lg:flex-row flex-1 gap-4 p-4">

        <div className="bg-[#e5f6fc] lg:flex-[0.5] p-4 rounded-lg shadow-sm h-fit lg:h-auto">
          <h2 className="text-lg sm:text-xl font-bold mb-4">Details</h2>
          <div className="space-y-6">
            <div>
              <label htmlFor="productName" className='text-sm sm:text-md font-semibold mb-2 block'>Product Name</label>
              <input
                id="productName"
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label htmlFor="productDescription" className="text-sm sm:text-md font-semibold mb-2 block">Description</label>
              <textarea
                id="productDescription"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={4}
                className="w-full p-2 border border-gray-300 rounded-md"
              ></textarea>
            </div>
            <div>
              <div className="text-sm sm:text-md font-semibold mb-2">Sizes</div>
              <div className="flex gap-4 flex-wrap">
                {sizes?.map((s, i) => (
                  <div key={i} className={`px-2 py-1 rounded-md text-sm ${!s.instock ? "line-through text-gray-500 bg-gray-200" : "bg-blue-100 text-blue-800"}`}>
                    {s.size}
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="text-sm sm:text-md font-semibold mb-2">Condition</div>
              <div className="text-sm sm:text-md">{condition}</div>
            </div>
            <div>
              <label htmlFor="retailPrice" className="text-sm sm:text-md font-semibold mb-2 block">Retail Price:</label>
              <input
                id="retailPrice"
                type="number"
                value={price}
                onChange={(e) => setPrice(Number(e.target.value))}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label htmlFor="retailPrice" className="text-sm sm:text-md font-semibold mb-2 block">SKU:</label>
              <input
                id="SKU"
                type="string"
                value={Sku}
                onChange={(e) => setPrice(Number(e.target.value))}
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div className="grid grid-cols-2 gap-4 text-xs sm:text-sm pt-4 border-t">
              <div>
                <div className="font-semibold">Created At:</div>
                <div>{Selectedproduct.createdAt && normalizeDateTime(Selectedproduct.createdAt)}</div>
              </div>
              <div>
                <div className="font-semibold">Updated At:</div>
                <div>{Selectedproduct.updatedAt && normalizeDateTime(Selectedproduct.updatedAt)}</div>
              </div>
            </div>
            <div className='flex justify-end'>
              <Button
              onClick={()=>{
                     UpdateProductDetails(Selectedproduct.id,Sku,price,title,description)
              }}
              className='bg-black text-white hover:bg-gray-800 px-4 py-2 rounded-md'>Save Changes</Button>
            </div>
          </div>
        </div>

      
        <div className="bg-white lg:flex-[1.3] rounded-lg shadow-sm p-4 space-y-8">
            <ImageGallery title="Current Images" images={selectedimg?selectedimg:[]} Selectedflag={true} />
            {/* <ImageGallery title="Suggested Images" images={similarimages!=null?similarimages:[""]} Selectedflag={false}/> */}
        </div>
      </div>

     
      <div className="  flex items-center justify-end gap-8 mb-4 ">
           <Button
            onClick={()=>Submit(Selectedproduct.id)}
           className='bg-[#1D7DBD]'>Re-Push</Button>
           <Button className="bg-white border-2 border-[#1D7DBD] text-[#1D7DBD]">Back</Button>

      </div>
    </div>
  );
};

export default Product;